import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div class="branding">
      @if(options.theme === 'light') {
      <a href="/dashboards/dashboard1">
        <img
          src="./assets/images/logos/lefticon.png"
          class="align-middle m-2 w-150"
          alt="logo"
        />
      </a>
      } @if(options.theme === 'dark') {
      <a href="/dashboards/dashboard1">
        <img
          src="./assets/images/logos/lefticon.png"
          class="align-middle m-2 w-150"
          alt="logo"
        />
      </a>
      }
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();

  constructor(private settings: CoreService) { }
}
